import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

/* ScrollTrigger.normalizeScroll(true); */

export default class Gnav {
    constructor() {
        this.init();

        window.onresize = () => {
            ScrollTrigger.refresh();
        };
    }

    init() {
        this.trigger = document.querySelector(".js-gnav_trigger");

        this.setCurrent();
        this.changeNavMode();
    }

    setCurrent() {
        const section = document.querySelectorAll(".js-section");
        const gnavitems = document.querySelectorAll(".js-gnav_item");

        section.forEach((el) => {
            const changeCurrent = () => {
                const sec = el.id;
                const gnavitem = document.querySelector(
                    `.js-gnav_item.-${sec}`
                );

                document.body.setAttribute("data-current",sec);

                gnavitems.forEach((el) => {
                    el.classList.remove("-active");
                });

                gnavitem.classList.add("-active");
            };

            ScrollTrigger.create({
                trigger: el,
                start: "top center",
                end: "bottom center",
                autoKill: false,
                //markers: true,
                onEnter: () => {
                    changeCurrent();
                },
                onEnterBack: () => {
                    changeCurrent();
                },
            });
        });
    }

    changeNavMode() {
        const triggerElm = document.querySelector(".introduction__cont__ttl");
        const triggerNav = document.querySelector(".l-gnav");

        ScrollTrigger.create({
            trigger: triggerElm,
            start: "top bottom",
            end: "top bottom",

            onLeave: () => {
                document.body.classList.add("-navmode");
            },
            onEnterBack: () => {
                document.body.classList.remove("-navmode");
            },
            once: false,
            //markers: true,
        });
    }
}